import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import axios, { AxiosError, type AxiosRequestConfig, type AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
  validateStatus: (status) => status >= 200 && status <= 600,
})

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    useCommonStore().loading = true
    config.headers.token = useUserStore().token || localStorage.getItem(import.meta.env.VITE_TOKEN_NAME) || ''
    return config
  },
  (err: AxiosError) => {
    console.error(err)
  },
)
// 响应拦截
instance.interceptors.response.use(
  (res) => {
    useCommonStore().loading = false
    if (res.status >= 300) {
      let message = `网络请求错误，错误：${res.data.message}，ErrorCode：${res.data.statusCode}`
      if (res.status === 429) {
        message = `请求过于频繁，休息一下吧`
      }
      ElMessage.error(message)
      throw new Error(res.statusText)
    }
    if (res.data.code !== 200) {
      ElMessage.error(res.data.message || '网络请求错误')
      throw new Error(res.data.message)
    } else {
      if (res.data.message && !res.config.headers.noMessage) ElMessage.success(res.data.message)
    }
    return res.data
  },
  (err: AxiosError) => {
    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
      ElMessage.error('网络请求超时，请重试')
    } else {
      ElMessage.error(`网络请求错误，错误：${err.message}`)
    }
    useCommonStore().loading = false
    console.error(err)
  },
)
export default function request<T>(config: AxiosRequestConfig) {
  return new Promise<T>((resolve, reject) => {
    instance
      .request<T>(config)
      .then((response: AxiosResponse<T>) => {
        resolve(response.data)
      })
      .catch((error: any) => {
        reject(error)
      })
  })
}
